import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { AddJobNoteDialog } from '@/features/jobs/details/components/JobNotesCard/AddJobNoteDialog'
import {
  type AddJobNoteDialogViewModel,
  MAX_NOTE_LENGTH,
} from './AddJobNoteDialogViewModel'

export interface AddJobNoteDialogContainerProps {
  vm: AddJobNoteDialogViewModel
}

export const AddJobNoteDialogContainer = observer(
  function AddJobNoteDialogContainer({ vm }: AddJobNoteDialogContainerProps) {
    return (
      <AddJobNoteDialog
        showing={vm.modal.showing}
        isSending={vm.sendNote.pending}
        canSend={vm.canSend}
        noteInput={
          <TextAreaContainer
            autoFocus
            data-private
            rows={5}
            label="Note"
            help="Add any relevant details or context. Notes can be seen by anyone with access to the job, minus the client."
            model={vm}
            field="composerText"
            isDisabled={vm.sendNote.pending}
            maxLength={MAX_NOTE_LENGTH}
            data-test="add-job-note-input"
          />
        }
        noteCharsRemaining={vm.noteCharsRemaining}
        recipients={vm.recipients.map((recipient) => ({
          userPublicId: recipient.userPublicId,
          name: recipient.name,
          role: recipient.role,
          selected: recipient.selected,
        }))}
        onToggleRecipient={vm.toggleRecipient}
        onSubmit={vm.sendNote}
        onClose={vm.modal.close}
      />
    )
  },
)
